import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type { ReturnRequestDto } from "../generated/schema";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request.ts";

interface UseUpdateReturnRequestCarrierParams {
  onSuccess: (returnRequest: ReturnRequestDto) => void;
  onError?: (error: unknown) => void;
}

export default function useUpdateReturnRequestCarrier(
  params: UseUpdateReturnRequestCarrierParams,
) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateReturnRequest = useInvalidateReturnRequest();

  return $api.useMutation(
    "patch",
    "/shops/{shopId}/return-requests/{returnRequestId}/carrier",
    {
      onSuccess(returnRequest) {
        successNotification();
        params.onSuccess(returnRequest);
        setTimeout(
          () =>
            invalidateReturnRequest({
              returnRequestId: returnRequest.id,
              shopId: returnRequest.shopId,
            }),
          100,
        );
      },
      onError(err) {
        errorNotification();
        params.onError?.(err);
      },
    },
  );
}
